/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'util/PropTypes';
import classnames from 'classnames';

import './toolbar.scss';
@observer
class ToolbarSection extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		const alignment = this.props.align;

		const classes = classnames({
			'explore-vis-toolbar__items': true,
			'explore-vis-toolbar__items--left': alignment === 'left',
			'explore-vis-toolbar__items--center': alignment === 'center',
			'explore-vis-toolbar__items--right': alignment === 'right',
			'explore-vis-toolbar__items--extright': alignment === 'extright' //extreme right
		});

		return (
			<div className={classes}>
				{this.props.children}
			</div>
		);
	}

}

ToolbarSection.propTypes = {
	align: PropTypes.string,
	children: PropTypes.any
};

ToolbarSection.defaultProps = {
	align: 'left',
	children: []
};

export default ToolbarSection;



// WEBPACK FOOTER //
// ./src/js/components/toolbar/ToolbarSection.js